import imgs from './imgs.js';
const data = [
    {
        "id": 1,
        "name": "Opryskiwacz spalinowy Stihl SR450",
        "description": "Komfortowy opryskiwacz o dużym zasięgu oprysku. Łatwy w obsłudze. Z pojemnym zbiornikiem. Szybkie uruchamianie urządzenia. Model wyposażony w praktyczny mechanizm do przezbrojenia 2w1, który umożliwia wykonywanie zarówno oprysków jak i rozpylanie granulatu.",
        "image": imgs.opryskiwacz,
        "category": "Opryskiwacze i dmuchawy",
        "technical_data": [
            {
                "name": "Ciężar",
                "value": "12,8 kg"
            },
            {
                "name": "Pojemność zbiornika na rozpylaną substancję",
                "value": "14l"
            },
            {
                "name": "Zawartość zbiornika paliw",
                "value": "1,7l"
            },
            {
                "name": "Maksymalny zasięg opryskiwania horyzontalnie",
                "value": "14,5m"
            }
        ],
        "price": {
            "rental_price": "120zł",
            "deposit": "300zł"
        }
    },
    {
        "id": 2,
        "name": "Nożyce spalinowe Stihl HS 45",
        "description": "Wyjątkowo lekkie nożyce do żywopłotów do pielęgnacji żywopłotów w przydomowym ogrodzie. Doskonałe do nadawania formy żywopłotom oraz krzewom do wysokości klatki piersiowej użytkownika. Specjalna geometria ostrza zapewnia czyste, precyzyjne cięcie. System antywibracyjny STIHL",
        "technical_data": [
            {
                "name": "Ciężar:",
                "value": "5 kg"
            },
            {
                "name": "Długość listwy tnącej ",
                "value": "60cm"
            }
        ],
        "price": {
            "rental_price": "80zł",
            "deposit": "200zł"
        },
        "image": imgs.nozyce2,
        "category": "Nożyce do żywopłotu i sekatory"
    },
    {
        "id": 3,
        "name": "Elektryczne nożyce do żywopłotów Stihl HS 81",
        "description": "Trwałe, elektryczne nożyce do żywopłotów, które przeznaczone są do cięcia twardych żywopłotów.",
        "technical_data": [
            {
                "name": "Silnik",
                "value": "1 KM"
            },
            {
                "name": "Długość ostrza",
                "value": "60cm"
            },
            {
                "name": "Ciężar",
                "value": "5,6kg"
            }
        ],
        "price": {
            "rental_price": "80zł",
            "deposit": "200zł"
        },
        "image": imgs.nozyce1,
        "category": "Nożyce do żywopłotu i sekatory"
    },

    {
        "id": 6,
        "name": "Kosa spalinowa Stihl FS 240",
        "description": "",
        "technical_data": [
            {
                "name": "Długość całkowita",
                "value": "180cm"
            },
            {
                "name": "Ciężar",
                "value": "6,9kg"
            },
            {
                "name": "Moc",
                "value": "11,7kW/2,3KM"
            },
            {
                "name": "Średnica cięcia",
                "value": "420mm"
            }

        ],
        "price": {
            "rental_price": "120zł",
            "deposit": "300zł"
        },
        "image": imgs.kosa,
        "category": "Kosiarki i kosy"
    },
    {
        "id": 7,
        "name": "Podkaszarka Stihl FS87",
        "description": "",
        "technical_data": [
            {
                "name": "Moc",
                "value": "1,3 KM"
            },
            {
                "name": "Ciężar",
                "value": "5,6kg"
            },

        ],
        "price": {
            "rental_price": "60zł",
            "deposit": "300zł"
        },
        "image": imgs.fs87,
        "category": "Kosiarki i kosy"
    },
    {
        "id": 8,
        "name": "Dmuchawa SH56",
        "description": "Idealna do oczyszczania średniej wielkości powierzchni. Płynna regulacja obrotów, dysza okrągła, nóż rozdrabniający, silnik 2-MIX. ",
        "technical_data": [
            {
                "name": "Ciężar",
                "value": "5,6kg"
            }

        ],
        "price": {
            "rental_price": "80zł",
            "deposit": "300zł"
        },
        "image": imgs.dmuchawa2,
        "category": "Opryskiwacze i dmuchawy"
    },
    {
        "id": 9,
        "name": "Dmuchawa Stihl BG86",
        "description": "Do oczyszczania dużych powierzchni z liści i skoszonej trawy. Filtr HD2 umożliwia zastosowanie urządzenia również w warunkach dużego zapylenia.",
        "technical_data": [
            {
                "name": "Waga",
                "value": "4,4kg"
            },
            {
                "name": "Wydajność",
                "value": "770m3/min"
            }

        ],
        "price": {
            "rental_price": "80zł",
            "deposit": "300zł"
        },
        "image": imgs.dmuchawa1,
        "category": "Opryskiwacze i dmuchawy"
    },
    {
        "id": 10,
        "name": "Wertykulator World",
        "description": "Korpus jest spawany ze stali i posiada szereg wzmocnień które czynią go bardzo solidnym.Posiada centralną 6-pozycyjną regulację wysokości w zakresie (-12mm do +12mm). Wertykulator posiada noże pływające",
        "technical_data": [
            {
                "name": "",
                "value": ""
            }

        ],
        "price": {
            "rental_price": "140zł",
            "deposit": "300zł"
        },
        "image": imgs.wertykulator,
        "category": "Wertykulatory i Aeratory"
    },
    {
        "id": 11,
        "name": "Glebogryzarka Viking HB 560",
        "description": "",
        "technical_data": [
            {
                "name": "Typ silnika",
                "value": "Kohler Serie XT675 OHV SC"
            },
            {
                "name": "Szerokość robocza",
                "value": "60cm"
            },
            {
                "name": "Ciężar urządzenia",
                "value": "41 kg"
            },

        ],
        "price": {
            "rental_price": "120zł",
            "deposit": "300zł"
        },
        "image": imgs.glebogryzarka,
        "category": "Glebogryzarki"
    },
    {
        "id": 12,
        "name": "Zagęszczarka 196CC",
        "description": "Zagęszczarka gruntu płytowa ubijak wibrator 196cc 6,5KM 90kg",
        "technical_data": [
            {
                "name": "Maksymalny posuw ",
                "value": "15m/min"
            },
            {
                "name": "Siła zagęszczenia",
                "value": "1300kg"
            },

        ],
        "price": {
            "rental_price": "100zł",
            "deposit": "300zł"
        },
        "image": imgs.zageszczarka2,
        "category": "Narzędzia budowlane"
    },
    {
        "id": 13,
        "name": "Zagęszczarka Belle 120kg",
        "description": "",
        "technical_data": [
            {
                "name": "Waga",
                "value": "120kg"
            },
            {
                "name": "Silnik",
                "value": "Honda GX 160 5,5KM"
            },
            {
                "name": "Szerokość płyty",
                "value": "50cm"
            },
            {
                "name": "Siła wymuszająca",
                "value": "20 kN"
            },
            {
                "name": "Prędkość przesuwu",
                "value": "25m / min"
            }

        ],
        "price": {
            "rental_price": "100zł",
            "deposit": "500zł"
        },
        "image": imgs.zageszczarka3,
        "category": "Narzędzia budowlane"
    },
    {
        "id": 14,
        "name": "Pilarka spalinowa Stihl MS391",
        "description": "",
        "technical_data": [
            {
                "name": "Moc",
                "value": "4,5 KM"
            },
            {
                "name": "Długość prowadnicy",
                "value": "38 / 45cm"
            },
            {
                "name": "Ciężar",
                "value": "7,2 kg"
            },

        ],
        "price": {
            "rental_price": "120zł",
            "deposit": "300zł"
        },
        "image": imgs.ms391,
        "category": "Piły i podkrzesywarki"
    },
    {
        "id": 15,
        "name": "Pilarka spalinowa Stihl MS200",
        "description": "",
        "technical_data": [
            {
                "name": "Moc",
                "value": "2,3 KM"
            },
            {
                "name": "Długość prowadnicy",
                "value": "33 / 45cm "
            },
            {
                "name": "Ciężar",
                "value": "3,5 kg"
            },

        ],
        "price": {
            "rental_price": "140zł",
            "deposit": "300zł"
        },
        "image": imgs.ms200,
        "category": "Piły i podkrzesywarki"
    },
    {
        "id": 16,
        "name": "Pilarka spalinowa Stihl MS193D",
        "description": "",
        "technical_data": [
            {
                "name": "Moc",
                "value": "1,8 KM"
            },
            {
                "name": "Ciężar",
                "value": "3,3 kg"
            }

        ],
        "price": {
            "rental_price": "140zł",
            "deposit": "300zł"
        },
        "image": imgs.ms193,
        "category": "Piły i podkrzesywarki"
    },
    {
        "id": 17,
        "name": "Przecinarka Stihl TS420",
        "description": "Uniwersalna przecinarka do prac budowlanych. Ściernica o średnicy 350 mm do cięć o głębokości do 125 mm. System antywibracyjny STIHL zapewnia precyzyjne i wygodne prowadzenie przecinarki",
        "technical_data": [
            {
                "name": "Moc",
                "value": "4,4 KM"
            },
            {
                "name": "Średnica tarczy tnącej",
                "value": "350mm"
            },
            {
                "name": "Ciężar",
                "value": "9,7 kg"
            },

        ],
        "price": {
            "rental_price": "100zł",
            "deposit": "300zł"
        },
        "image": imgs.ts420,
        "category": "Narzędzia budowlane"
    },
    {
        "id": 18,
        "name": "Piaskarka/Rozsiewacz ziemi Dakr ",
        "description": "Rozsiewacz Dakr KRR jest przeznaczony do wykonywania zabiegów top-dressingu (piaskowania) na boiskach, w parkach i ozdobnych trawnikach.Praca z rozsiewaczem nie wymaga dużego wysiłku, duże koła sprawiają, że maszynę prowadzi się lekko. Dźwignia przy rączce aktywuje funkcję rozsiewania, a regulacja ilości podawanego materiału umożliwia dostosowanie grubości warstwy piasku to warunków i typu zabiegu.",
        "technical_data": [
            {
                "name": "Pojemność zbiornika",
                "value": "180 litrów"
            },
            {
                "name": "Szerokość robocza",
                "value": "70cm"
            },
            {
                "name": "Waga",
                "value": "40kg"
            },

        ],
        "price": {
            "rental_price": "120zł",
            "deposit": "300zł"
        },
        "image": imgs.dakr1,
        "category": "Siewniki, walce, rozsiewacze"
    },
    {
        "id": 19,
        "name": "Taczka Cedrus",
        "description": "Transporter spalinowy Cedrus TR300 to idealna maszyna do transportu wszelkiego rodzaju materiałów. Silnik czterosuwowy o pojemności 196cm3 pozwala na wydajną pracę w każdych warunkach. Terenowe opony z agresywnym bieżnikiem pomagają w trudnym terenie budowy. Mechaniczna przekładnia z 3 przełożeniami do przodu oraz biegiem wstecznym pozwala dostosować prędkość do wykonywanej pracy oraz przewożonego materiału.",
        "technical_data": [
            {
                "name": "Łatwe manewrowanie w wąskich miejscach np. przez wąskie drzwi i konstrukcje",
                "value": ""
            },
            {
                "name": "Solidna konstrukcja ze stali",
                "value": ""
            },
            {
                "name": "Bezobsługowa przekładnia",
                "value": ""
            },
            {
                "name": "Prosta obsługa",
                "value": ""
            },
            {
                "name": "Mocny 4-suwowy silnik spalinowy OHV ",
                "value": ""
            },
            {
                "name": "Na wytrzymałych terenowych oponach",
                "value": ""
            },
            {
                "name": "Przewożenie dużych ładunków",
                "value": ""
            },
            {
                "name": "Zastąpić może tradycyjną taczkę w wielu miejscach",
                "value": ""
            },

        ],
        "price": {
            "rental_price": "150zł",
            "deposit": "500zł"
        },
        "image": imgs.taczki,
        "category": "Taczki i przyczepki"
    },
    {
        "id": 20,
        "name": "Crawler Spider CMC S18",
        "description": "",
        "technical_data": [
            {
                "name": "Wysokość robocza",
                "value": "17,7 m"
            },
            {
                "name": "Maksymalny zasięg poziomy",
                "value": "11,3 m"
            },
            {
                "name": "Waga",
                "value": "2490 kg"
            },
            {
                "name": "Udźwig",
                "value": "230 kg"
            },
            {
                "name": "Długość transportowa",
                "value": "5,3 m"
            },
            {
                "name": "Szerokość transportowa",
                "value": "1,06 m"
            },
            {
                "name": "Wysokość transportowa",
                "value": "2,28 m"
            },
            {
                "name": "Silnik",
                "value": "Honda GX390"
            },
            {
                "name": "Liczba osób na platformie",
                "value": "2"
            }
        ],
        "price": {
            "rental_price": "600zł",
            "deposit": "4000zł"
        },
        "image": imgs.crawler,
        "category": "Podnośniki"
    },
    {
        "id": 42,
        "name": "Avant 630",
        "description": "",
        "technical_data": [
            {
                "name": "Udźwig nominalny",
                "value": "1190 kg"
            },
            {
                "name": "Wysokość podnoszenia",
                "value": "2835 mm"
            },
            {
                "name": "Prędkość maksymalna",
                "value": "23 km/h"
            },
            {
                "name": "Moc silnika",
                "value": "19 kW (26 KM)"
            }
        ],
        "price": {
            "rental_price": "700zł",
            "deposit": "3000zł"
        },
        "image": imgs.avant630,
        "category": "Minikoparki"
    },
    {
        "id": 21,
        "name": "Rębak Timberwolf",
        "description": "Silny, wytrzymały, mocny i szybki. Taki jest TW 230DHB. Tam gdzie pracę należy wykonać szybko i bez zbędnego zamieszania. Łatwy w konserwacji i transporcie. Waży poniżej 750 kg, więc można holować go z kategorią B. ",
        "technical_data": [
            {
                "name": "Maksymalna średnica materiału",
                "value": "160mm"
            },
            {
                "name": "Masa własna",
                "value": "749kg"
            },
            {
                "name": "Otwór załadowczy",
                "value": "230 x 160mm"
            },
            {
                "name": "Wydajność rębaka",
                "value": "5 t/h"
            },
            {
                "name": "Napęd rębaka",
                "value": "Kubota 35 KM 4-cylindrowy"
            },

        ],
        "price": {
            "rental_price": "600zł",
            "deposit": "2000zł"
        },
        "image": imgs.rebak,
        "category": "Rębaki"
    },
    {
        "id": 22,
        "name": "Walec, napowietrzacz",
        "description": "",
        "technical_data": [
            {
                "name": "Szerokość",
                "value": "60cm"
            }
        ],
        "price": {
            "rental_price": "40zł",
            "deposit": "50zł"
        },
        "image": imgs.walec,
        "category": "Siewniki, walce, rozsiewacze"
    },
    {
        "id": 23,
        "name": "Drabina",
        "description": "",
        "technical_data": [
            {
                "name": "Wysokość robocza",
                "value": "9m"
            }

        ],
        "price": {
            "rental_price": "70zł",
            "deposit": "250zł"
        },
        "image": imgs.drabina,
        "category": "Narzędzia techniczne"
    },
    {
        "id": 24,
        "name": "Przyczepka",
        "description": "",
        "technical_data": [
            {
                "name": "Udźwig",
                "value": "500kg"
            },
            {
                "name": "Wymiary",
                "value": "150cm x 200cm"
            }

        ],
        "price": {
            "rental_price": "50zł",
            "deposit": "200zł"
        },
        "image": imgs.przeczepka,
        "category": "Taczki i przyczepki"
    },
    {
        "id": 25,
        "name": "Siewnik Wolf Garten",
        "description": "",
        "technical_data": [
            {
                "name": "Pojemność zbiornika",
                "value": "15L"
            },
            {
                "name": "Szerokość siewu",
                "value": "41cm"
            }

        ],
        "price": {
            "rental_price": "40zł",
            "deposit": "50zł"
        },
        "image": imgs.siewnik,
        "category": "Siewniki, walce, rozsiewacze"
    },
    {
        "id": 26,
        "name": "Areator rurkowy Weibang WB457AB",
        "description": "Aerator rurkowy Weibang WB457AB to profesjonalne narzędzie do napowietrzania gleby. Dzięki niemu znikną problemy z optymalnym nawadnianiem i napowietrzaniem trawnika. Rurki z wysokogatunkowej stali wbijają się w glebę umożliwiając wnikanie przez nią wody, związków organicznych i powietrza ułatwiając ich odbiór przez system korzeniowy traw.",
        "technical_data": [
            {
                "name": "",
                "value": ""
            }
        ],
        "price": {
            "rental_price": "250zł",
            "deposit": "500zł"
        },
        "image": imgs.agregator,
        "category": "Wertykulatory i Aeratory"
    },
    {
        "id": 27,
        "name": "Kosiarka spalinowa Castel Garden XC 53 HS ",
        "description": "",
        "technical_data": [
            {
                "name": "Wysokość koszenia",
                "value": "27 do 90mm"
            },
            {
                "name": "Szerokość koszenia",
                "value": "51cm"
            },
            {
                "name": "Regulacja wysokości koszenia",
                "value": "centralna"
            },
            {
                "name": "Koła",
                "value": "200 / 280mm"
            },
            {
                "name": "Pojemność kosza",
                "value": "60 litrów"
            },
            {
                "name": "Pojemność silnika",
                "value": "167 cm3"
            },

        ],
        "price": {
            "rental_price": "80zł",
            "deposit": "250zł"
        },
        "image": imgs.kosiarka2,
        "category": "Kosiarki i kosy"
    },
    {
        "id": 28,
        "name": "Kosiarka spalinowa z napędem Viking 46cm",
        "description": "",
        "technical_data": [
            {
                "name": "Powierzchnia trawnika m²",
                "value": "do 1200"
            },
            {
                "name": "Typ silnika",
                "value": "B&S Serie 575 EX OHV RS"
            },
            {
                "name": "Moc znamionowa",
                "value": "2,1 kW/2,8 KM"
            },
            {
                "name": "Szerokość koszenia",
                "value": "46cm"
            },
            {
                "name": "Wysokość koszenia",
                "value": "25-75cm"
            },
            {
                "name": "Pojemność kosza na trawę",
                "value": "55l"
            },
            {
                "name": "Ciężar urządzenia",
                "value": "26kg"
            },
            {
                "name": "Napęd kół",
                "value": "1V (1 biegowy)"
            },
            {
                "name": "Urządzenie (Dł./Szer./Wys.)",
                "value": "147cm x 50cm x 111cm"
            },

        ],
        "price": {
            "rental_price": "80zł",
            "deposit": "250zł"
        },
        "image": imgs.kosiarka3,
        "category": "Kosiarki i kosy"
    },

    {
        "id": 31,
        "name": "Laser krzyżowy PRO LK-180 G",
        "description": "Laser krzyżowy LK-180G generuje jedną wiązkę pionową oraz jedną wiązkę poziomą, obie o  zakresie pracy poszerzonym do 180°. Zielone diody laserowe generują bardzo kontrastowe, dobrze widoczne linie, do 4 razy jaśniejsze niż w laserze czerwonym o tej samej mocy. Tryb pracy z detektorem wiązki laserowej, zwiększającym zasięg lasera. Linie lasera przecinają się pod kątem 90°. Wyposażony w magnetyczną podstawę z montowanym do ściany zaczepem oraz mosiężnymi gwintami 1/4”” i 5/8””. Łatwy montaż na statywie lub tyczce o gwintach 1/4”” lub 5/8””. Specyfikacja techniczna:b Źródło lasera:dioda pół przewodnikowa=515-520 nm Moc:<1mW każda wiązka, klasa II Dokładność:	+/-1mm/5m (+/-0,2mm/1m) Zakres samopoziomowania:	4o  +/- 1o Szerokość linii	mniej niż 3,5mm/ 10m System samopoziomujący: wahadło magnetyczne Zakres roboczy do 15m w pomieszczeniu zależnie od naświetlenia oraz 40m przy użyciu detektora Zasilanie:3xbateria alkaliczna AA Czas pracy ok. 4 godzin Wymiary: 90mmx70mmx90mm Waga(z bateriami) 400g Kąt linii poziomej/pionowej: 180o/180o Temperatura pracy: -5oC - 40oC Temperatura przechowywania: -20oC - 70oC Wyposażenie: Laser krzyżowy LK-180G Uniwersalny uchwyt magnetyczny z ruchomą głowicą i gwintem 1/4",
        "technical_data": [
            {
                "name": "",
                "value": ""
            }

        ],
        "price": {
            "rental_price": "40zł",
            "deposit": "200zł"
        },
        "image": imgs.laserk,
        "category": "Elektronarzędzia"
    },
    {
        "id": 32,
        "name": "Młotowiertarka akumulatorowa bezprzewodowa DHR241Z 18V 1.9J Makita",
        "description": "",
        "technical_data": [
            {
                "name": "Siła uderzeniowa",
                "value": "1.9J"
            },
            {
                "name": "Średnica wiercenia w betonie",
                "value": "20mm"
            },
            {
                "name": "Funkcja przecinania",
                "value": "Tak"
            },
            {
                "name": "Napięcie",
                "value": "18V"
            },
            {
                "name": "Średnica wiercenia w drewnie",
                "value": "26mm"
            },
            {
                "name": "Średnica wiercenia w metalu",
                "value": "13mm"
            },
            {
                "name": "Czas ładowania",
                "value": "90 minut"
            },
            {
                "name": "Typ uchwytu",
                "value": "SDS Plus"
            }

        ],
        "price": {
            "rental_price": "40zł",
            "deposit": "150zł"
        },
        "image": imgs.mlotowiertarka,
        "category": "Elektronarzędzia"
    },
    {
        "id": 33,
        "name": "Bezolejowy Kompresor FMXCMD156HE FATMAX",
        "description": "",
        "technical_data": [
            {
                "name": "Moc",
                "value": "1100 W/1,5hk"
            },
            {
                "name": "Maks ciśnienie robocze",
                "value": "8 bar"
            },
            {
                "name": "Gwarantowany poziom mocy akustycznej",
                "value": "97dB"
            },
            {
                "name": "Pojemność zbiornika",
                "value": "6l"
            },
            {
                "name": "Napięcie",
                "value": "230V"
            },
            {
                "name": "Wydajność",
                "value": "180 l/min"
            },
            {
                "name": "Wydajność efektywna",
                "value": "130 l/min"
            }

        ],
        "price": {
            "rental_price": "80zł",
            "deposit": "250zł"
        },
        "image": imgs.kompresor,
        "category": "Narzędzia budowlane"
    },
    {
        "id": 34,
        "name": "DECA Spawarka transformatorowa PARVA 145E",
        "description": "",
        "technical_data": [
            {
                "name": "Zasilanie",
                "value": "230V"
            },
            {
                "name": "Bezpiecznik",
                "value": "16A"
            },
            {
                "name": "Moc silnika",
                "value": "2-4 kW"
            },
            {
                "name": "Napięcie obwodu otwartego",
                "value": "44-48 V"
            },
            {
                "name": "Zakres prądu sparowania",
                "value": "40-140A"
            },
            {
                "name": "Średnica zalecanych elektrod",
                "value": "1,6 - 3,2mm"
            },
            {
                "name": "Rozmiar",
                "value": "380 x 210 x 280mm"
            },
            {
                "name": "Masa",
                "value": "14,5kg"
            }

        ],
        "price": {
            "rental_price": "80zł",
            "deposit": "250zł"
        },
        "image": imgs.spawarka,
        "category": "Narzędzia budowlane"
    },
    {
        "id": 35,
        "name": "RIWALL PRO DZIDA 1500 SZLIFIERKA ŻYRAFA",
        "description": "",
        "technical_data": [
            {
                "name": "Moc silnika znamionowa",
                "value": "1500 W"
            },
            {
                "name": "Tarcze szlifierskie Ø",
                "value": "225 mm"
            },
            {
                "name": "Prędkość obr. tarczy szlifierskiej okrągłej",
                "value": "1000 – 1850 /min"
            },
            {
                "name": "Długość regulowana",
                "value": "110-180cm"
            },
            {
                "name": "Króćce odciągowe: Ø ",
                "value": "wew. 45 / zew. 50 mm"
            },
            {
                "name": "Waga",
                "value": "4,5 kg"
            }

        ],
        "price": {
            "rental_price": "90zł",
            "deposit": "300zł"
        },
        "image": imgs.szlifierka2,
        "category": "Narzędzia budowlane"
    },
    {
        "id": 36,
        "name": "Makita DGA511Z Szlifierka Kątowa, 18 V, Czarny/Niebieski",
        "description": "",
        "technical_data": [
            {
                "name": "Źródło",
                "value": "Zasilanie bateryjne"
            },
            {
                "name": "Napięcie",
                "value": "18w"
            },
            {
                "name": "Moc",
                "value": "50W"
            },
            {
                "name": "Maksymalna prędkość obrotowa",
                "value": "8,5"
            },
            {
                "name": "Technologia wykrywania aktywnego sprzężenia zwrotnego",
                "value": ""
            },
            {
                "name": "Technologia automatycznego napędu momentu obrotowego ADT",
                "value": ""
            }

        ],
        "price": {
            "rental_price": "60zł",
            "deposit": "250zł"
        },
        "image": imgs.szlifierka1,
        "category": "Elektronarzędzia"
    },
    {
        "id": 37,
        "name": "Odkurzacz przemysłowy wodny",
        "description": "",
        "technical_data": [
            {
                "name": "Waga",
                "value": "6,5kg"
            },
            {
                "name": "Napięcie",
                "value": "230V"
            },
            {
                "name": "Zasięg",
                "value": "6,8m"
            },
            {
                "name": "Pojemność",
                "value": "25l"
            },
            {
                "name": "Przepływ powietrza",
                "value": "2m3/min"
            },
            {
                "name": "Długość węża",
                "value": "1,8m"
            },
            {
                "name": "Poziom hałasu",
                "value": "78dB"
            },
            {
                "name": "Długość kabla",
                "value": "5m"
            },
            {
                "name": "Moc",
                "value": "1200 W"
            }

        ],
        "price": {
            "rental_price": "30zł",
            "deposit": "100zł"
        },
        "image": imgs.odkurzacz,
        "category": "Elektronarzędzia"
    },
    {
        "id": 38,
        "name": "Nożyce akumlatorowe Stihl HSA 56",
        "description": "",
        "technical_data": [
            {
                "name": "Waga",
                "value": "3,5kg"
            },
            {
                "name": "Długość cięcia",
                "value": "45cm"
            },
            {
                "name": "Długość całkowita",
                "value": "94cm"
            },
            {
                "name": "Orientacyjny czas pracy z akumlatorem AK 10",
                "value": "do 40min"
            },
            {
                "name": "Orientacyjny czas pracy z akumlatorem AK 20",
                "value": "do 80min"
            }


        ],
        "price": {
            "rental_price": "150zł",
            "deposit": "300zł"
        },
        "image": imgs.nozyce3,
        "category": "Nożyce do żywopłotu i sekatory"
    },
    {
        "id": 39,
        "name": "Nożyce na wysięgniku kombi system",
        "description": "",
        "technical_data": [
            {
                "name": "Moc",
                "value": "0,9 kW / 1,2KM"
            },
            {
                "name": "Pojemność",
                "value": "24,1 cm3"
            },
            {
                "name": "Długość listwy tnącej",
                "value": "60cm"
            },
            {
                "name": "Długość całkowita",
                "value": "242cm"
            },
            {
                "name": "Ilość skoków",
                "value": "3.615/ min"
            }


        ],
        "price": {
            "rental_price": "120zł",
            "deposit": "300zł"
        },
        "image": imgs.kombii,
        "category": "Nożyce do żywopłotu i sekatory"
    },
    {
        "id": 40,
        "name": "Wertykulator Weibang WB384RB",
        "description": "",
        "technical_data": [
            {
                "name": "Silnik",
                "value": "Briggs & Stratton XR750"
            },
            {
                "name": "Pojemność silnika",
                "value": "163 cm³"
            },
            {
                "name": "Moc",
                "value": "3,7 kW"
            },
            {
                "name": "Szerokość robocza",
                "value": "38 cm"
            },
            {
                "name": "Maks. głębokość pracy",
                "value": "16 mm"
            },
            {
                "name": "Ilość noży",
                "value": "22"
            },
            {
                "name": "Pojemność kosza",
                "value": "40 l"
            },
            {
                "name": "Waga",
                "value": "46 kg"
            },
            {
                "name": "Zalecana powierzchnia",
                "value": "do 2000 m²"
            }
        ],
        "price": {
            "rental_price": "120zł",
            "deposit": "300zł"
        },
        "image": imgs.weibangWertykulator,
        "category": "Wertykulatory i Aeratory"
    },
    {
        "id": 41,
        "name": "Glebogryzarka spalinowa Stihl MH 685",
        "description": "",
        "technical_data": [
            {
                "name": "Typ silnika",
                "value": "EVC 200.3 C"
            },
            {
                "name": "Pojemność skokowa",
                "value": "139 cm³"
            },
            {
                "name": "Moc",
                "value": "2,3 kW / 3,1 KM"
            },
            {
                "name": "Szerokość robocza",
                "value": "45 cm"
            },
            {
                "name": "Maks. szerokość robocza",
                "value": "60 cm"
            },
            {
                "name": "Pojemność zbiornika paliwa",
                "value": "0,9 l"
            },
            {
                "name": "Ciężar",
                "value": "36 kg"
            }
        ],
        "price": {
            "rental_price": "270zł",
            "deposit": "500zł"
        },
        "image": imgs.stihlMh685,
        "category": "Glebogryzarki"
    },
]
export default data;